export class ContactRequest {

    subject: string;

    content: string;

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/model/contact-request.ts